module.exports = __webpack_public_path__ + "static/media/nft-real-estate-icon1.c0b0577f.svg";